import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../util/Localizer'

class NoResources extends Component {
  render () {
    return (
      <div>
        <Row middle='xs'>
          <Col lg={10}>
            <p className='emptyStateText'>{localize('pages.Resources.noResources')}</p>
          </Col>
        </Row>
      </div>

    )
  }
}

export default NoResources



// WEBPACK FOOTER //
// ./src/widgets/resources/noResources.js